export default defineNuxtPlugin(async () => {
  const agreementsStore = useAgreementsStore()
  try {
    await agreementsStore.load()
  } catch {
    /**/
  }
})
